import OntruckMarginCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['net_margin', 'currency', 'has_xdock_shipper_order'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const {
      net_margin: margin,
      currency,
      has_xdock_shipper_order,
    } = props.selectors.getJourneyFields(state, props.journeyId, fields);

    return {
      margin,
      currency,
      showMargin: !has_xdock_shipper_order,
    };
  })
);

export default enhance(OntruckMarginCell);
